import { useTranslation } from 'react-i18next';
import { Flex } from 'reflexbox';
import moment from 'moment';

import * as graphql from 'generated/graphql';
import Column from 'packages/kakapo-ui-kit/components/grid/Column';
import { SectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';
import LanguageSelector from 'packages/kakapo-ui-kit/components/forms/controls/LanguageSelector';
import Paragraph from 'packages/kakapo-ui-kit/components/common/Paragraph';
import { HorizontalAlignment } from 'packages/kakapo-ui-kit/types/Layout';
import PlainHorizontalCard from 'packages/kakapo-ui-kit/components/cards/PlainHorizontalCard';
import useAuthenticatedUser from 'packages/kakapo-ui-application/hooks/useAuthenticatedUser';

export function UserSettingsLanguage() {
	const { t } = useTranslation();

	const authenticatedUser = useAuthenticatedUser();

	const [updateUserLocale] = graphql.useUpdateUserLocaleMutation();

	const handleLanguageChange = async (languageId: 'nl' | 'en') => {
		await updateUserLocale({
			variables: {
				input: {
					userID: authenticatedUser.id,
					locale: {
						nl: 'nl_NL',
						en: 'en_US',
						de: 'de_DE',
						fr: 'fr_FR',
					}[languageId],
				},
			},
		});

		moment.locale(languageId);
	};

	return (
		<PlainHorizontalCard>
			<Column mb={2}>
				<Paragraph color="slateBlue">{t('common.language.title')}</Paragraph>
			</Column>
			<LanguageSelector
				onLanguageChange={handleLanguageChange}
				dropdownAlignment={HorizontalAlignment.Left}
			/>
		</PlainHorizontalCard>
	);
}

export default function UserSettingsContainer() {
	const { t } = useTranslation();

	return (
		<Flex justifyContent="center">
			<Column my={[4, 4, 5]} width={[1, 10 / 12, 10 / 12]}>
				<Column width={[1, 1, 8 / 12]}>
					<SectionTitle>{t('common.settings.title')}</SectionTitle>

					<Column mt={2} width={1}>
						<UserSettingsLanguage />
					</Column>
				</Column>
			</Column>
		</Flex>
	);
}
